import { render, staticRenderFns } from "./About.vue?vue&type=template&id=29f7e930&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=29f7e930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f7e930",
  null
  
)

export default component.exports